/**
 * Messages 的权限码（main-api app/web/api/v1/controllers/sys/chat_controller.py；
 * capability chat.use 覆盖全部三个）。
 */
export const CHAT_PERMISSIONS = {
  /** 会话列表、消息页、联系人、未读数、实时 token */
  query: 'system:chat:query',
  /** 读一个会话 */
  read: 'system:chat:read',
  /** 发起会话、发消息、标已读、群管理、图片上传 */
  send: 'system:chat:send',
} as const
